import { render, staticRenderFns } from "./BrokenLinks.vue?vue&type=template&id=4b3c2081&scoped=true"
import script from "./BrokenLinks.vue?vue&type=script&lang=js"
export * from "./BrokenLinks.vue?vue&type=script&lang=js"
import style0 from "./BrokenLinks.vue?vue&type=style&index=0&id=4b3c2081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c2081",
  null
  
)

export default component.exports